import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex mb-2 mx-2 items-center info" }
const _hoisted_2 = { class: "w-full h-min sm:h-48 sm:h-min" }
const _hoisted_3 = { class: "flex relative items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "overflow-x-auto informationList m-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "font-bold mb-2 w-1/3 text-center min-w-max px-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "font-bold mb-2 w-1/3 text-center min-w-max px-2"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "list-none text-xs sm:text-base"
}
const _hoisted_14 = { class: "font-bold mb-2 w-1/3 text-center min-w-max px-2" }
const _hoisted_15 = {
  key: 1,
  class: "informationCardTable mt-2 ml-2"
}


import Table from '../components/DataTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationCard',
  props: ['information', 'teamTotal'],
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.information.image !== undefined)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.information.image,
              alt: "Image",
              class: "w-28 h-20 sm:w-auto sm:h-48 mr-5"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.information.data, (info, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              class: "list-none text-xs sm:text-base"
            }, [
              (Array.isArray(info.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (info.value.length !== 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(key) + ": ", 1))
                      : _createCommentVNode("", true),
                    (info.value.length !== 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(info.value.join(" ")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (info.value !== undefined && info.value !== '')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(key) + ": ", 1))
                      : _createCommentVNode("", true),
                    (info.value !== undefined && info.value !== '' && info.value.toString().length < 50)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(info.value), 1))
                      : _createCommentVNode("", true),
                    (info.value !== undefined && info.value !== '' && info.value.toString().length >= 50)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(info.value.slice(0, 40) + '...'), 1))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          }), 128)),
          (__props.teamTotal)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(__props.teamTotal) + " Members", 1)
              ]))
            : _createCommentVNode("", true),
          (__props.information.tableInfo !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(Table, {
                  data: __props.information.tableInfo.data,
                  columns: __props.information.tableInfo.columns,
                  removeCount: true,
                  class: "w-auto text-[0.50rem] sm:text-base"
                }, null, 8, ["data", "columns"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})